// extracted by mini-css-extract-plugin
export default {"filterComp":"ProductFilter_filterComp__IgEnw","category":"ProductFilter_category__kAa3E","active":"ProductFilter_active__F3ZJ3","btn":"ProductFilter_btn__SuF98"};